import React, {Component} from 'react';
import {
    Grid,
    Paper,
    Typography
} from 'material-ui';
import {
    getDisplayNameOrNull,
    displayStaffArrays
} from '../../components/helpers/helpers';
import {BackButton} from '../../components/buttons/BackButton';

class StaffViewContent extends Component {

    render() {
        const {
            staffMember,
            classes
        } = this.props;

        const staffFullName = staffMember.firstname + ' ' + staffMember.name;

        return (
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <div className={classes.staffViewHeading}>
                        <p className={classes.staffViewLead}>View details for "{staffFullName}"</p>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Paper elevation={2} className={classes.staffViewContent}>
                        <Grid container spacing={24}>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">Title:
                                    <p className={classes.staffContentParagraph}>{getDisplayNameOrNull(staffMember.title_name)}</p>
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">Name:
                                    <p className={classes.staffContentParagraph}>{getDisplayNameOrNull(staffFullName)}</p>
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">Jobs:
                                    <p className={classes.staffContentParagraph}>{displayStaffArrays(staffMember.jobs)}</p>
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">Teams:
                                    <p className={classes.staffContentParagraph}>{displayStaffArrays(staffMember.teams)}</p>
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">Offices:
                                    <p className={classes.staffContentParagraph}>{displayStaffArrays(staffMember.sites)}</p>
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">Destinations:
                                    <p className={classes.staffContentParagraph}>{displayStaffArrays(staffMember.products)}</p>
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">Image:
                                    {staffMember.image !== null ? <img src={staffMember.image.preview} className={classes.imageViewStaff} alt="Projects Abroad Staff"/>
                                    : <p className={classes.staffContentParagraph}>There is no photo uploaded for this staff member!</p>}
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">Description:
                                    <p className={classes.staffContentParagraph} dangerouslySetInnerHTML={{__html: staffMember.description}}></p>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid container spacing={0}>
                    <Grid item xs={12} className={classes.buttons}>
                        <BackButton
                            link={"/staff"}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

export default StaffViewContent;



// WEBPACK FOOTER //
// ./src/containers/staff/StaffViewContent.jsx